<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户信息</span>
      </div>
      <div class>
        <el-form ref="firstForm" :model="firstForm" :rules="firstFormRules" label-width="80px">
          <el-form-item label="用户姓名" prop="userName">
            <el-input
              v-model="firstForm.userName"
              style="width:200px"
              placeholder="请输入用户姓名"
            />
          </el-form-item>
          <el-form-item label="用户账号">
            <el-input v-model="firstForm.loginName" placeholder="请输入用户账号" disabled />
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNum">
            <el-input
              v-model="firstForm.phoneNum"
              style="width:200px"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item label="用户卡号">
            <el-select
              v-model="firstForm.cardNum"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索关键词"
              :remote-method="selectChargeModule"
            >
              <el-option
                v-for="item in chargeCardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="归属城市" prop="cityCode">
            <el-cascader ref="three" v-model="firstForm.cityCode" :options="optionsThree" placeholder="请选择省市" :props="{ checkStrictly: true }" clearable />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">车辆信息</span>
      </div>
      <el-form ref="secondForm" :model="secondForm" label-width="80px">
        <el-form-item
          v-for="(item, index) in secondForm.vehicles"
          :key="index"
          label="车牌号"
        >
          <el-input
            v-model="item.plateNumber"
            style="width:200px"
            placeholder="上传行驶证后自动显示"
            disabled
          />
          <!-- <el-button
            style="margin:0 10px"
            @click="isDefault(index)"
          >{{ item.isDefault ? "已设置为默认" : "设为默认" }}</el-button> -->
          <el-button
            style="margin:0 10px"
            @click="upLoadCar(index, item)"
          >添加车辆</el-button>
          <el-switch
            v-model="item.isDefault"
            style="width:140px"
            :active-text="item.isDefault ? '已设置为默认' : '设为默认'"
            :disabled="item.isDefault ? true : false"
            @change="isDefult($event,index)"
          />
          <el-button style="margin:0 10px" icon="el-icon-plus" circle :disabled="item.plateNumber != '' ? false : true" @click="hasMore" />
          <el-button icon="el-icon-minus" circle @click="hasLess(index)" />
        </el-form-item>
        <el-form-item style="margin-top:50px;text-align: center;">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
      <el-dialog
        v-dialogDrag
        :title="isOCR?'上传行驶证':'添加车辆信息'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="50%"
        center
      >
        <el-form
          ref="form2"
          :model="form2"
          :rules="isOCR?form2Rules:form2Rules1"
          label-width="100px"
        >
          <div style="display:flex;justify-content: space-around">
            <el-form-item v-if="isOCR" prop="registrationFront">
              <el-upload
                ref="upImg"
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                name="file"
                :data="imgData1"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
                  <i class="el-icon-delete" />
                </span>
                <i v-else class="iconfont icon-xiangji" style="display:flex;flex-direction: column;text-align: center;">
                  <span>正本</span>
                </i>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="isOCR" prop="registrationAfter">
              <el-upload
                ref="upImg"
                class="avatar-uploader"
                :action="action2"
                :headers="headers"
                name="file"
                :data="imgData2"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :on-remove="handleRemove2"
                :before-upload="beforeAvatarUpload"
                accept="image/png,image/jpg,image/jpeg"
              >
                <img v-if="imageUrl2" :src="imageUrl2" class="avatar">
                <span v-if="imageUrl2" class="el-upload-action" @click.stop="handleRemove2()">
                  <i class="el-icon-delete" />
                </span>
                <i v-else class="iconfont icon-xiangji" style="display:flex;flex-direction: column;text-align: center;">
                  <span>副本</span>
                </i>
              </el-upload>
            </el-form-item>
          </div>
          <el-row :gutter="25">
            <el-col :span="11" style="margin-left: 20px;">
              <el-form-item label="车牌号码" prop="plateNumber">
                <el-input
                  v-model="form2.plateNumber"
                  placeholder="请输入车牌号码"
                  :readonly="isReadonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11" style="margin-left: 20px;">
              <el-form-item label="车辆类型" prop="type">
                <el-input
                  v-model="form2.type"
                  placeholder="请输入车辆类型"
                  :readonly="isReadonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <el-col :span="11" style="margin-left: 20px;">
              <el-form-item label="品牌型号" prop="model">
                <el-input
                  v-model="form2.model"
                  placeholder="请输入品牌型号"
                  :readonly="isReadonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11" style="margin-left: 20px;">
              <el-form-item label="车辆识别代码" prop="vin">
                <el-input
                  v-model="form2.vin"
                  placeholder="请输入车辆VIN"
                  :readonly="isReadonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <el-col :span="11" style="margin-left: 20px;">
              <el-form-item label="所有人" prop="owner">
                <el-input
                  v-model="form2.owner"
                  placeholder="请输入所有人"
                  :readonly="isReadonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item style="border-top:1px solid #eee;padding-top:15px;text-align: center;">
            <el-button @click="cancel2">取消</el-button>
            <el-button
              type="primary"
              @click="submit(true)"
            >保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { regionData, provinceAndCityData } from 'element-china-area-data'
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Xiugaifeiqiye',
  components: {},
  data() {
    return {
      optionsThree: provinceAndCityData, // 省市数据
      isOCR: false,
      dialogVisible: false,
      isReadonly: true,
      chargeCardList: [],
      firstForm: {
        userName: '',
        loginName: '',
        phoneNum: '',
        cardNum: '',
        cityCode: []
      },
      firstFormRules: {
        userName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' }
        ],
        phoneNum: [
          { required: true, message: '请输入正确的手机号码', pattern: /^1[23456789]\d{9}$/, trigger: 'blur' }
        ],
        cityCode: [{
          required: true,
          message: '请选择归属城市',
          trigger: 'change'
        }]
      },
      secondForm: {
        vehicles: [{
          plateNumber: '',
          type: '',
          model: '',
          vin: '',
          owner: '',
          registrationFront: '',
          registrationAfter: '',
          register_date: '',
          engine_num: '',
          issue_date: '',
          use_character: '',
          addr: '',
          isDefault: false
        }]
      },
      form2: {
        plateNumber: '',
        type: '',
        model: '',
        vin: '',
        owner: '',
        registrationFront: '',
        registrationAfter: '',
        register_date: '',
        engine_num: '',
        issue_date: '',
        use_character: '',
        addr: '',
        isDefault: false
      },
      form2Rules: {
        registrationFront: [
          { required: true, message: '请上传行驶证正本', trigger: 'blur' }
        ],
        registrationAfter: [
          { required: true, message: '请上传行驶证副本', trigger: 'blur' }
        ]
      },
      form2Rules1: {
        plateNumber: [{
          required: true,
          message: '请输入车牌号',
          trigger: 'blur'
        }],
        // type: [{
        //   required: true,
        //   message: '请输入车辆类型',
        //   trigger: 'blur'
        // }],
        // model: [{
        //   required: true,
        //   message: '请输入品牌型号',
        //   trigger: 'blur'
        // }],
        // vin: [{
        //   required: true,
        //   message: '请输入车辆VIN',
        //   trigger: 'blur'
        // }],
        // owner: [{
        //   required: true,
        //   message: '请输入所有人',
        //   trigger: 'blur'
        // }]
      },
      imageUrl: '',
      imageUrl2: '',
      imgData1: {
        'isocr': 'true',
        'side': 'face'
      },
      imgData2: {
        'isocr': 'true',
        'side': 'back'
      },
      index: '',
      id: '',
      token: window.localStorage.getItem('token')
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    },
    action2() {
      return HOST + '/oss'
    }
  },
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
    this.getDataDetail()
    this.getOcrData()

    // this.form2 = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    cancel2() {
      this.form2 = {
        plateNumber: '',
        type: '',
        model: '',
        vin: '',
        owner: '',
        registrationFront: '',
        registrationAfter: '',
        register_date: '',
        engine_num: '',
        issue_date: '',
        use_character: '',
        addr: '',
        isDefault: false
      }
      // 查看已保存的行驶证信息，点击取消，不应该把信息置空；未保存行驶证信息，点击取消，置空信息
      if (!this.secondForm.vehicles[this.index].isSaved) {
        this.secondForm.vehicles[this.index] = this.form2
      }
      this.imageUrl = ''
      this.imageUrl2 = ''
      this.dialogVisible = false
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.firstForm.validate()
        ])
      } catch (error) {
        return
      }

      const vehicles = []
      for (let i = 0; i < this.secondForm.vehicles.length; i++) {
        if (this.secondForm.vehicles[i].plateNumber) {
          vehicles.push(this.secondForm.vehicles[i])
        }
      }

      const data = {
        id: this.id,
        userName: this.firstForm.userName,
        mobile: this.firstForm.phoneNum,
        chargingCardId: this.firstForm.cardNum,
        vehicles: vehicles,
        cityCode: this.firstForm.cityCode.join(',')
      }
      console.log(data)
      this.$store.dispatch('form/handle', {
        url: '/user/account',
        data: data,
        method: 'post',
        callback: res => {
          this.$router.go(-1)
        }
      })
    },

    // 是否设为默认
    isDefult(e, index) {
      for (let i = 0; i < this.secondForm.vehicles.length; i++) {
        if (i === index) {
          this.secondForm.vehicles[i].isDefault = true
        } else {
          this.secondForm.vehicles[i].isDefault = false
        }
      }
      this.$forceUpdate()
    },

    // 上传行驶证
    upLoadCar(index, item) {
      this.index = index
      this.form2 = JSON.parse(JSON.stringify(item))
      if (item.registrationFront != '') {
        this.imageUrl = HOST + '/oss?objectName=' + item.registrationFront + '&token=' + this.token
      }
      if (item.registrationAfter != '') {
        this.imageUrl2 = HOST + '/oss?objectName=' + item.registrationAfter + '&token=' + this.token
      }
      if (this.isOCR) {
        this.isReadonly = true
      } else {
        this.isReadonly = false
      }
      this.dialogVisible = true
    },

    // 添加行驶证
    hasMore() {
      this.secondForm.vehicles.push({
        plateNumber: '',
        type: '',
        model: '',
        vin: '',
        owner: '',
        registrationFront: '',
        registrationAfter: '',
        register_date: '',
        engine_num: '',
        issue_date: '',
        use_character: '',
        addr: '',
        isDefault: false
      })
      this.imageUrl = ''
      this.imageUrl2 = ''
    },

    // 删除车辆
    hasLess(index) {
      if (this.secondForm.vehicles.length === 1) {
        this.secondForm.vehicles = [{
          plateNumber: '',
          type: '',
          model: '',
          vin: '',
          owner: '',
          registrationFront: '',
          registrationAfter: '',
          register_date: '',
          engine_num: '',
          issue_date: '',
          use_character: '',
          addr: '',
          isDefault: false
        }]
      } else {
        this.secondForm.vehicles.splice(index, 1) }
    },

    // 保存行驶证到数组
    async submit() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form2.validate()
        ])
      } catch (error) {
        return
      }
      this.form2.isSaved = true
      this.secondForm.vehicles[this.index] = JSON.parse(JSON.stringify(this.form2))
      this.form2 = {
        plateNumber: '',
        type: '',
        model: '',
        vin: '',
        owner: '',
        registrationFront: '',
        registrationAfter: '',
        register_date: '',
        engine_num: '',
        issue_date: '',
        use_character: '',
        addr: '',
        isDefault: false
      }
      this.imageUrl = ''
      this.imageUrl2 = ''
      this.dialogVisible = false
    },

    handleAvatarSuccess(res, file) {
      this.isReadonly = false
      this.imageUrl = URL.createObjectURL(file.raw)
      this.form2.plateNumber = res.data.ocr.plate_num
      this.form2.type = res.data.ocr.vehicle_type
      this.form2.model = res.data.ocr.model
      this.form2.vin = res.data.ocr.vin
      this.form2.owner = res.data.ocr.owner
      this.form2.register_date = res.data.ocr.register_date
      this.form2.engine_num = res.data.ocr.engine_num
      this.form2.issue_date = res.data.ocr.issue_date
      this.form2.use_character = res.data.ocr.use_character
      this.form2.addr = res.data.ocr.addr
      this.form2.registrationFront = res.data.fileName
    },
    // 删除照片
    handleRemove() {
      this.imageUrl = ''
      this.form2.plateNumber = ''
      this.form2.type = ''
      this.form2.model = ''
      this.form2.vin = ''
      this.form2.owner = ''
      this.form2.register_date = ''
      this.form2.engine_num = ''
      this.form2.issue_date = ''
      this.form2.use_character = ''
      this.form2.addr = ''
      this.form2.registrationFront = ''
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw)
      this.form2.registrationAfter = res.data.fileName
    },
    // 删除照片
    handleRemove2() {
      this.imageUrl2 = ''
      this.form2.registrationAfter = ''
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === 'image/png' ||
          file.type === 'image/jpg' ||
          file.type === 'image/jpeg'
        )
      ) {
        this.$notify.warning({
          title: '警告',
          message:
            '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
    },

    selectChargeModule(val) {
      const data = {
        cardNum: val
      }
      this.$store.dispatch('form/handle', {
        url: '/user/chargingCard/findCardNum',
        method: 'get',
        data: data,
        callback: resp => {
          this.chargeCardList = resp
        }
      })
    },
    getOcrData() {
      this.$store.dispatch('form/handle', {
        url: '/setting/getOcr',
        method: 'get',
        callback: resp => {
          this.isOCR = resp
        }
      })
    },

    getDataDetail(val) {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/user/account/getDataDetail',
        method: 'get',
        data: data,
        callback: resp => {
          this.chargeCardList = [{
            label: resp.cardNum,
            value: resp.cardNumValue
          }]
          this.firstForm.userName = resp.userName
          this.firstForm.loginName = resp.loginName
          this.firstForm.phoneNum = resp.phoneNum
          this.firstForm.cardNum = resp.cardNumValue
          this.secondForm.vehicles = resp.list.length != 0 ? resp.list : this.secondForm.vehicles
          this.firstForm.cityCode = resp.cityCode ? resp.cityCode.split(',') : []
          if (resp.cardNumValue == '') {
            this.selectChargeModule()
          }
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  /deep/.el-input {
    width: 200px !important;
  }

  /deep/.el-dialog__wrapper .el-input {
    width: 100% !important;
  }

  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #1890FF;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-action {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    font-size: 0;
    color: #fff;
    text-align: center;
    line-height: 150px;
  }

  .el-upload-action:hover {
    font-size: 20px;
    background-color: rgba(0, 0, 0, .3)
  }

  .d-flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .iconfont {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0 10px;
  }

  .avatar {
    width: 300px;
    height: 150px;
    display: block;
  }

  .avatar {
    width: 300px;
    height: 150px;
    display: block;
  }

  /deep/.el-dialog .el-dialog__header {
    display: flex;
    background: #FFFFFF;
    border-bottom: 2px solid #eeeeee;
  }

  /deep/.el-dialog__title {
    float: left !important;
    font-size: 18px !important;
    color: #000000 !important;
  }

  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #909399 !important;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/.el-dialog__body .el-form-item__label {
    width: auto !important;
  }

  /deep/.el-dialog__body .el-form-item {
    margin-bottom: 20px;
  }

  /deep/.el-dialog {
    margin-top: 3% !important;
  }

  /deep/.el-dialog--center .el-dialog__body {
    padding: 25px 25px 10px 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/userManagement/reviseIsenterprise.vue